<div class="container-fluid" *ngIf="costReviewGeneralConditions && isSectionVisible">
    <fieldset class="border rounded-3 p-1" [class.section-disabled]="isSectionLocked">
        <legend class="float-none w-auto px-1 ml-1 font-size-13">
            @if (optionalWorkflowCondition) {
            <si-check-box [isReadMode]="false" [isDisabled]="isDisabled || isReadOnlyMode"
                [isChecked]="isConditionsChecked" (change)="onConditionsToggle($event)"></si-check-box>
            }
            {{'REVIEW_SOL_CONDITIONS_TAB.TITLE' | translate}}
        </legend>
        <div class="row" [appOptionalWorkflow]="optionalWorkflowCondition" [initialExpanded]="true"  [formGroup]="costReviewSOLConditionFormGroup">
            <div class="col-sm-6">
                <div class="row bottomPadding" [formGroup]="costReviewSOLConditionFormGroup" trackChanges
                    *ngIf="showFieldAlways()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.MINORITY_REQUIREMENTS' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class=" d-flex align-items-center" formControlName="minority">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldAlways()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.PREVAILING_WAGE_REQUIREMENTS' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="prevailingWage">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldOnlyIfApplicable()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.TRADE_AGREEMENT_ACT_REQUIRED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="tradeAgreementAct">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldAlways()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.BUY_AMERICA_REQUIRED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="buyAmerica">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldAlways()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.BUY_AMERICAN_ACT_REQUIRED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="buyAmericanAct">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldOnlyIfApplicable()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.BIM_MODELLING_REQUIRED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="bimModeling">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldOnlyIfApplicable()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.SCHEDULER_ESTIMATE_RECEIVED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="schedulerEstimate">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="showFieldOnlyIfApplicable()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.TRAVEL_EXPENSES_PLANNED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 mt-3">
                        <span class="addPadding">{{(costReviewGeneralConditions?.travelExpensesPlanned ?? '') | multilingualCurrency}}</span>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="(business === constants.BUSINESS_SECURITY)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.SPARE_HARDWARE_SOFTWARE_CAPACITY_REQUIRED' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="hardwareSoftwareCapacity">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"
                               ></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"
                               ></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="(business === constants.BUSINESS_SECURITY)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.SERVICE_CONTRACT_REQUIRED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="serviceContract">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="(business === constants.BUSINESS_SECURITY) && isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.SPECIAL_PROGRAMMING_REQUIRED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="specialProgramming">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding "
                    *ngIf="(business === constants.BUSINESS_SECURITY) && isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label class="ms-3">{{'REVIEW_SOL_CONDITIONS_TAB.IF_YES_DESCRIBE' |
                            translate}}</mat-label>

                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field [isDisabled]="!isFeildEnabled('specialProgramming')" [maxlength]="40"
                            [isReadMode]="false" formControlName="ifyesdesc"></app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="(business === constants.BUSINESS_SECURITY)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.SPECIAL_COMMISSIONING_PROCEDURES_REQUIRED' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center"
                            formControlName="specialCommissioningProceduresRequired">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                       </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="(business === constants.BUSINESS_SECURITY)">
                    <div class="col-sm-6">
                        <mat-label class="ms-3">{{'REVIEW_SOL_CONDITIONS_TAB.IF_YES_TEST_PROCESS_REVIEWED' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="testProcessReviewed">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="!isFeildEnabled('specialCommissioningProceduresRequired')"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="!isFeildEnabled('specialCommissioningProceduresRequired')"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="(business === constants.BUSINESS_SECURITY)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.SPECIAL_TAGGING_LABELING_REQUIRED' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="taggingLabeling">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="(business === constants.BUSINESS_SECURITY)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.SPECIAL_INSTALLATION_STANDARDS_REQUIRED' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                         <mat-radio-group class="d-flex align-items-center" formControlName="installationStandards">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="(business === constants.BUSINESS_SECURITY)">
                    <div class="col-sm-6">
                        <mat-label class="ms-3">{{'REVIEW_SOL_CONDITIONS_TAB.IF_YES_DESCRIBE' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field [isDisabled]="!isFeildEnabled('installationStandards')" formControlName="ifYesInstallationStandards"
                            [isReadMode]="isReadOnlyMode" [maxlength]="40"></app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="(business === constants.BUSINESS_SECURITY)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.LOCAL_CODE_RESTRICTIONS_FOR_INSTALLED_DOOR_HARDWARE' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="localCodeRestrictions">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldForFireOnly() && isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.PARKING_FEES' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 mt-3">
                        <span class="addPadding">{{costReviewGeneralConditions.parkingFees | multilingualCurrency}}</span>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="showFieldAlways()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.OVERTIME_PWR_ESTIMATED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 mt-3">
                        <span class="addPadding">{{costReviewGeneralConditions?.overtimeEstimated}}</span>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="showFieldAlways()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.ESCALATION_INCLUDED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 mt-3">
                        <span class="addPadding">{{costReviewGeneralConditions?.escalationIncluded}}</span>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldOnlyIfApplicable()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.TRAILER_RENTAL_SPACE_REQUIRED' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="trailerRentalSpace">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="((business === constants.BUSINESS_AUTOMATION || business === constants.BUSINESS_ELECTRICAL || this.business === this.constants.BUSINESS_MECHANICAL) && isSalePriceGreaterThan150)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.UTILITIES_COSTS_ESTIMATED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="utilitiesCosts">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                @if(business === constants.BUSINESS_AUTOMATION || business === constants.BUSINESS_ELECTRICAL || this.business === this.constants.BUSINESS_MECHANICAL || this.business === this.constants.BUSINESS_FIRE) {
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.PROJECT_IS_PHASED' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="d-flex align-items-center" formControlName="projectIsPhased">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(costReviewSOLConditionFormGroup, 'projectIsPhased')"></si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(costReviewSOLConditionFormGroup, 'projectIsPhased')"></si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label class="ms-3">{{'REVIEW_SOL_CONDITIONS_TAB.IF_YES_DESCRIBE' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6 break-word">
                            <app-si-form-field formControlName="ifYesDescribe"
                                [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || !isFeildEnabled('projectIsPhased')"></app-si-form-field>
                        </div>
                    </div>
                }
            </div>
            <div class="col-sm-6">
                <div class="row bottomPadding"
                    *ngIf="(business === constants.BUSINESS_SECURITY)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.ESCORTS_REQUIRED_IN_WORK_AREAS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <!-- <span>{{getParameterValues(constants.YES_NO,costReviewSecurityEnUsGeneralConditions?.escortsRequired)}}</span> -->
                        <mat-radio-group class="d-flex align-items-center" formControlName="escortsRequired">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="(business === constants.BUSINESS_SECURITY)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.CUSTOMER_TAX_EXEMPT' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="customerTaxExempt">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="(business === constants.BUSINESS_SECURITY)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.OVERTIME_PWR_ESTIMATED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 mt-3">
                        <span class="addPadding">{{costReviewSecurityEnUsGeneralConditions?.overtimeEstimated}}</span>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="(business === constants.BUSINESS_SECURITY)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.ESCALATION_INCLUDED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 mt-3">
                        <span class="addPadding">{{costReviewSecurityEnUsGeneralConditions?.escalationIncluded}}</span>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldOnlyIfApplicable()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.OFFICE_SUPPLIES_COSTS_ESTIMATED' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="officeSuppliesCosts">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldAlways()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.LIFT_COSTS_ESTIMATED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="liftCosts">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldOnlyIfApplicable()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.BIM_360_FIELD_CONFIGURATION_ESTIMATED' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="bim360FieldConfiguration">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldForFireOnly()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.TAX_REQUIRED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="taxRequired">
                            <si-radio-button [displayText]="'SALES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'USE' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NONE' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showSalesTaxField()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.SALES_TAX_REQUIRED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="salesTax">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="showFieldAlways()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.SPARE_PARTS_REQUIRED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="sparepartpercent" [isDisabled]="isDisabled" [type]="'percent'"
                            [isReadMode]="isReadOnlyMode" [formControlClass]="'justify-content-center'"></app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showEquipmentField()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.EQUIPMENT_ENCLOSURES_REQUIRED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="equipmentEnclosures">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldAlways()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.DEVICE_ACCESS_PANELS_REQUIRED' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="deviceAccessPanels">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldForFireOnly()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.SPARE_POINT_CAPACITY' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="sparepointcapacity" [type]="'percent'" [attr.min]= "0" [attr.max] = "100"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [formControlClass]="'justify-content-center'"></app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldOnlyIfApplicable()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.FIELD_PROCUREMENT_MANAGER_ASSIGNED' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="fieldProcurementManager">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldOnlyIfApplicable()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.TEMPORARY_SITE_PERSONNEL' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-3">
                        <si-check-box-group formControlName="temporarySitePersonnel" [isReadMode]="isReadOnlyMode"
                         [isDisabled]="isDisabled" [options]="temporarySitePersonnelList" [columnsPerRow]="2"></si-check-box-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="showFieldOnlyIfApplicable()">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.SERVICE_CONTRACT_REQUIRED_AS_PART_OF_THE_BID' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center"
                            formControlName="serviceContractGeneralConditions">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="(business === constants.BUSINESS_SECURITY)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.UNION_LABOR_REQUIRED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex" formControlName="unionLabor">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="(business === constants.BUSINESS_SECURITY)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.PREVAILING_WAGES_REQUIRED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex" formControlName="prevailingWages">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="(business === constants.BUSINESS_SECURITY)">
                    <div class="col-sm-6">
                        <mat-label
                            class="ms-3">{{'REVIEW_SOL_CONDITIONS_TAB.IF_YES_CERTIFIED_PAYROLL_REPORTS_REQUIRED'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex" formControlName="certifiedPayrollReports">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="!isFeildEnabled('prevailingWages')"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="!isFeildEnabled('prevailingWages')"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="(business === constants.BUSINESS_SECURITY && isSalePriceGreaterThan150)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.TRAVEL_EXPENSES_PLANNED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 mt-3">
                        <span class="addPadding">{{costReviewSecurityEnUsGeneralConditions?.travelExpensesPlanned ?? ''| multilingualCurrency}}</span>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="checkSellPriceForCPM">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CONDITIONS_TAB.CPM_HOURS_ESTIMATED' | translate}}</mat-label>
                        <mat-icon class="info-icon" [matTooltipDisabled]="isDisabled" [matTooltip]="'REVIEW_SOL_CONDITIONS_TAB.CPM_HOURS_ESTIMATED_INFO' | translate">info</mat-icon>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="d-flex align-items-center" formControlName="cpmHoursEstimated">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="container-fluid"
    *ngIf="business === constants.BUSINESS_FIRE && !showSectionNotApplicableMsg && !isSectionVisible">
    <fieldset class="border rounded-3 p-1">
        <legend class="float-none w-auto px-1 ml-1 font-size-13">{{'REVIEW_SOL_CONDITIONS_TAB.TITLE' | translate}}
        </legend>
        <div class="row bottomPadding">
            <div class="col-sm-12">
                <span>{{'REVIEW_SOL_CONDITIONS_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
            </div>
        </div>
    </fieldset>
</div>
<div class="container-fluid customizeText" *ngIf="showSectionNotApplicableMsg && !costReviewGeneralConditions  && !showConditionData()">
    {{'REVIEW_SOL_CONDITIONS_TAB.CONDITIONS_DATA_NOT_FOUND' | translate}}
</div>

